import type { Column } from 'react-table';
import type { Statistics } from 'feature-components/reports/item-assessment-report';
import {
  CategoryCol,
  NationalPercentageCol,
  PercentageCorrectCol,
  QuestionCol,
  QuestionDescriptionCol,
  ScaleDifficultyCol
} from 'feature-components/reports/item-assessment-report/columns/common-columns';
import type { TestType } from 'services/assist-api/entities/test/tests';

export default function getMathematicsColumns(
  canHaveStyledQuestionType: boolean,
  showReferenceData: boolean,
  testType: TestType | undefined
): Column<Statistics>[] {
  return [
    { ...QuestionCol({ canHaveStyledQuestionType, testType }), width: 80 },
    { ...CategoryCol('math'), disableSortBy: false },
    { ...QuestionDescriptionCol, disableSortBy: false },
    ScaleDifficultyCol,
    PercentageCorrectCol(showReferenceData),
    showReferenceData && NationalPercentageCol
  ].filter(Boolean);
}
